import { ref } from 'vue';

// localStorage is not reactive, so stores that derive state from the stored access
// token cannot see in-SPA token writes (login without a page reload, token refresh,
// impersonation switch). The auth store bumps this signal on every token write;
// derived state watches it to re-read the token.
//
// This lives in its own leaf module because auth.ts cannot import admin.ts directly
// (admin.ts -> middleware.ts -> auth.ts would become a cycle).
export const tokenVersion = ref(0);

export function notifyTokenChanged(): void {
    tokenVersion.value += 1;
}
